module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Sport Aluminum + White Open.7f1e9275.png";